export const LOADER_STATUS = "boilderplate/ITC04/Analytics/LOADER_STATUS";
export const FILE_DATA = "boilderplate/ITC04/Analytics/FILE_DATA";
